import { Print } from "@mui/icons-material";
import theme from "theme";
import { ManagementCard } from "./ManagementCard";

interface ViewLensSpecificationProps {
  onClick: () => void;
}

export const ViewLensSpecification = ({ onClick }: ViewLensSpecificationProps) => {
  return (
    <ManagementCard
      title="Lens Specification"
      onClick={onClick}
      Icon={Print}
      color={theme.palette.grey[500]}
      id="lens-admin-management-view-specification"
    />
  );
};
